import ApiService from '@zola-helpers/client/dist/es/http/api';

export interface UnrespondedMessagesResponse {
  unreadTotal: number;
}
export interface InquiryListResponse {
  offset: number;
  limit: number;
  has_more_results: boolean;
  // didn't bring in the full type for entities since we only care whether the length of this array is more than 0
  // if we ever need other data from the array, this should be updated
  entities: Record<string, unknown>[];
}

export function getUnreadCount(): Promise<UnrespondedMessagesResponse> {
  return ApiService.get(`/web-marketplace-api/v1/inquiry/unread-count`);
}

export function getInquiryList(): Promise<InquiryListResponse> {
  return ApiService.post(`/web-marketplace-api/v1/inquiry/account/list`);
}
